import React from 'react';

const Photos = () => {
    return (
        <div id="thePhotos">
            <div id="pageTitleContainer" class="clearfix" >
                <div class="leftFlower"></div>
                <div id="pageTitle">
                    <h2>THE</h2>
                    <h1>PHOTOS</h1>
                </div>
                <div class="rightFlower" ></div>
            </div>
            <br />
            This was moved to: <a href="https://photos.app.goo.gl/i6N5tD3hRVPLZj4v9" target="_blank">Google Photos</a>
        </div>
    );
};

export default Photos;